@let $buttons = buttons();
@let $template = template();

@if ($template && $buttons?.length) {
  <ng-template [ngTemplateOutlet]="$template" />
  <ng-template [ngTemplateOutlet]="defaultButtons" />
}

@if (($template && !$buttons?.length) || (!$template && $buttons?.length)) {
  <ng-container [ngTemplateOutlet]="$template || defaultButtons" />
}

<ng-template #defaultButtons>
  @for (button of buttonsData(); track button?.id ?? button) {
    @if (!button.hide) {
      <button
        #buttonElementItem
        [attr.data-e2e]="button.e2eLocator"
        [disabled]="button.loading || (button.disabled ?? disabled())"
        [ngbTooltip]="button?.tooltip"
        [ngClass]="button.classes"
        [type]="button.btnType || 'button'"
        (click)="button?.blurAfterClick ? buttonElementItem?.blur() : null; buttonClick.emit(button)">
        @if (button.icon; as icon) {
          <span [ngClass]="[icon]"></span>
        }
        {{ button.text }}
      </button>
    }
  }
</ng-template>
